<template>
  <div class="app-form" v-if="isActive">
    <v-modal-window v-model="isWindowFormActive" @toggle="formToggleEventHandler()">
      <div class="app-form__header-container">
        <div class="app-form__title">
          <span>Отправить заявку на подключение</span>
        </div>
        <div class="app-form__description">
          <span>Укажите контактные данные и выберите интересующие услуги. Менеджер по работе с корпоративными клиентами свяжется с вами в течение часа или в указанное время.</span>
        </div>
      </div>
      <div class="app-form__contact-data-container">
        <div class="app-form__field">
          <v-textbox
            ref="name"
            :placeholder="'Имя'"
            :name="'name'"
            v-model="form.fields.name"
            :required="true"
          />
        </div>
        <div class="app-form__field">
          <v-textbox
            ref="phone"
            :type="'tel'"
            :placeholder="'Телефон'"
            :name="'phone'"
            v-model="form.fields.phone"
            :required="true"
          />
        </div>
        <div class="app-form__field">
          <v-textbox
            ref="company"
            :placeholder="'Название компании'"
            :name="'company_name'"
            v-model="form.fields.company"
            :required="true"
          />
        </div>
        <div class="app-form__field">
          <v-textbox
            ref="address"
            :placeholder="'Адрес'"
            :name="'address'"
            v-model="form.fields.address"
            :required="true"
          />
        </div>
      </div>
      <div class="app-form__services-container">
        <div class="app-form__services-label">Услуги</div>
        <div class="app-form__services-checkboxes">
          <div class="app-form__service">
            <v-checkbox v-model="form.services.internet">Высокоскоростной интернет</v-checkbox>
          </div>
          <div class="app-form__service">
            <v-checkbox v-model="form.services.telephony">Телефония в офис</v-checkbox>
          </div>
          <div class="app-form__service">
            <v-checkbox v-model="form.services.wifi">Wi-Fi с авторизацией</v-checkbox>
          </div>
          <div class="app-form__service">
            <v-checkbox v-model="form.services.sip">SIP («Софтфон»)</v-checkbox>
          </div>
          <div class="app-form__service">
            <v-checkbox v-model="form.services.ats">Облачная АТС</v-checkbox>
          </div>
          <div class="app-form__service">
            <v-checkbox
              v-model="form.services.virtual_network"
            >Виртуальные частные сети (VPN L2, L3)</v-checkbox>
          </div>
          <div class="app-form__service">
            <v-checkbox v-model="form.services.tv">Цифровое телевидение</v-checkbox>
          </div>
          <div class="app-form__service">
            <v-checkbox v-model="form.services.other">Другое</v-checkbox>
          </div>
        </div>
      </div>
      <div class="app-form__preferred-time-container">
        <div class="app-form__field">
          <v-textbox
            ref="preferredTime"
            :placeholder="'В какое время вам можно позвонить?'"
            :name="'call_time'"
            v-model="form.preferredTime"
          />
        </div>
      </div>
      <div class="app-form__sent-request-container">
        <div class="app-form__sent-request-button-container">
          <v-button
            class="app-form__sent-request-button"
            @click="sentRequest()"
          >Отправить</v-button>
        </div>
        <div class="app-form__agreement-container">
          <span>
            Отправляя форму, я даю согласие на
            <a
              href="https://b2b.redcom.ru/politic/"
            >обработку персональных данных</a>
          </span>
        </div>
      </div>
    </v-modal-window>
    <v-process-spinner v-model="isProcessActive"/>
    <v-modal-window v-model="isWindowCompleteActive" @toggle="formToggleEventHandler()">
      <div class="app-form__result-container">
        <div class="app-form__result-img-container">
          <img
            class="app-form__result-img"
            src="../assets/icon_checked.png"
          >
        </div>
        <div class="app-form__result-label-container">
          <span>Ваша заявка успешно отправлена</span>
        </div>
        <div class="app-form__result-button-container">
          <v-button @click="formToggleEventHandler()">Ок</v-button>
        </div>
      </div>
    </v-modal-window>
  </div>
</template>

<script>
import VModalWindow from "./VModalWindow.vue";
import VProcessSpinner from "./VProcessSpinner.vue";
import VButton from "./VButton.vue";
import VCheckbox from "./VCheckbox.vue";
import VTextbox from "./VTextbox.vue";

import api from "../api";

export default {
  name: "AppForm",
  components: {
    VModalWindow: VModalWindow,
    VProcessSpinner: VProcessSpinner,
    VButton: VButton,
    VCheckbox: VCheckbox,
    VTextbox: VTextbox
  },
  data() {
    return {
      form: {
        fields: {
          name: null,
          phone: null,
          company: null,
          address: null
        },
        services: {
          internet: false,
          telephony: false,
          wifi: false,
          sip: false,
          ats: false,
          virtual_network: false,
          tv: false,
          other: false
        },
        preferredTime: null
      },
      isActive: false,
      isWindowFormActive: false,
      isWindowCompleteActive: false,
      isProcessActive: false,
      isProcessComplete: false
    };
  },
  watch: {
    isActive: newValue => {
      if (newValue) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = null;
      }
    }
  },
  methods: {
    toggle() {
      this.formToggleEventHandler();
    },
    formToggleEventHandler() {
      this.isActive = !this.isActive;
      this.isWindowFormActive = !this.isProcessComplete;
      this.isWindowCompleteActive = this.isProcessComplete;
    },
    windowFormToggleEventHandle() {
      this.formToggleEventHandler();
    },
    windowCompleteToggleEventHandler() {
      this.formToggleEventHandler();
    },
    checkFormValidity() {
      let results = [
        this.$refs["name"].checkValidity(),
        this.$refs["phone"].checkValidity(),
        this.$refs["company"].checkValidity(),
        this.$refs["address"].checkValidity()
      ];

      return !results.includes(false);
    },
    sentRequest() {
      if(this.checkFormValidity()){
        this.isProcessActive = true;

        api.SentRequest(this.form).then(result => {
          this.isProcessActive = false;
          this.isProcessComplete = true;
          this.isWindowFormActive = false;
          this.isWindowCompleteActive = true;
        });

      } else {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    }
  }
};
</script>

<style>
.app-form {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  z-index: 99;
}

.app-form__header-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 0;
}

.app-form__title {
  max-width: 310px;
  font-size: 36px;
  line-height: 42px;
}

.app-form__description {
  color: rgb(104, 104, 104);
  text-align: justify;
  font-size: 14px;
  line-height: 25px;
  max-width: 400px;
}

.app-form__contact-data-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.app-form__field,
.app-form__service {
  margin-top: 30px;
  max-width: 400px;
  width: 100%;
}

.app-form__services-label {
  margin-top: 40px;
}

.app-form__services-checkboxes {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.app-form__sent-request-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 45px;
  margin-bottom: 45px;
}

.app-form__agreement-container {
  font-size: 14px;
}

.app-form__agreement-container a {
  color: rgb(2, 142, 212);
}

.app-form__result-container {
  display: flex;
  flex-direction: column;
}

.app-form__result-img-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
  width: 120px;
  background: #f6f6fb;
  border-radius: 100px;
}

.app-form__result-img {
  width: 60%;
}

.app-form__result-label-container {
  text-align: center;
  font-size: 35px;
}

.app-form__result-button-container {
  max-width: 100px;
  width: 100%;
}

.app-form__result-img-container,
.app-form__result-label-container,
.app-form__result-button-container {
  margin: 40px auto;
}

@media only screen and (max-width: 1290px) {
  .app-form__title {
    min-width: 100%;
    text-align: center;
  }

  .app-form__description {
    min-width: 100%;
    margin-top: 25px;
    text-align: center;
  }

  .app-form__field,
  .app-form__service {
    min-width: 100%;
  }

  .app-form__agreement-container {
    max-width: 245px;
  }
}

@media only screen and (max-width: 600px) {
  .app-form__header-container,
  .app-form__contact-data-container,
  .app-form__services-container,
  .app-form__preferred-time-container,
  .app-form__sent-request-container {
    margin: 5px 25px;
  }

  .app-form__sent-request-container {
    flex-direction: column;
  }

  .app-form__sent-request-button-container,
  .app-form__agreement-container {
    margin: 10px 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
